import { ProIp } from "./ApiURL";

//Cancel Membership  Api Url

export const deleteMemberShipAPI = ProIp + "cancelSubscripRoutes/deleteMembersCreation/";